import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";


export const StudyMaterialCartCountSlice = createSlice({
  name: "StudyMaterialCartCountSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    StudyMaterialCartCount: (state) => {
      state.isLoading = true;
    },
    successStudyMaterialCartCount: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureStudyMaterialCartCount: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearStudyMaterialCartCount: (state) => {
      state.data = {};
    },
  },
});

export const {
  StudyMaterialCartCount,
  successStudyMaterialCartCount,
  failureStudyMaterialCartCount,
  clearStudyMaterialCartCount,
} = StudyMaterialCartCountSlice.actions;

export default StudyMaterialCartCountSlice.reducer;
